import * as React from "react";
const SvgFiRrRefund = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-refund_svg__a)">
      <path
        fill="#062147"
        d="M2 6V1a1 1 0 1 1 2 0v5c0 .552.449 1 1 1h6c.551 0 1-.448 1-1V1a1 1 0 1 1 2 0v5c0 1.654-1.346 3-3 3H5C3.346 9 2 7.654 2 6m5.962-3c1.311 0 2.589-.841 2.997-2.013A.746.746 0 0 0 10.253 0H5.747a.746.746 0 0 0-.706.987C5.449 2.159 6.651 3 7.962 3m15.275 10.015-6.805 7.638a10 10 0 0 1-7.466 3.348H4.001c-2.206 0-4-1.794-4-4v-5c0-2.206 1.794-4 4-4h8.858c1.139 0 2.138.609 2.689 1.519l3.216-3.534a3 3 0 0 1 2.086-.981 3 3 0 0 1 2.168.782 3.02 3.02 0 0 1 .219 4.228m-1.566-2.751a1 1 0 0 0-.728-.263c-.27.013-.519.13-.7.329l-4.426 4.864a3.16 3.16 0 0 1-2.515 2.059l-5.16.737a1 1 0 0 1-.283-1.981l5.161-.737c.56-.079.981-.565.981-1.13 0-.63-.512-1.143-1.142-1.143H4c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h4.965a8.01 8.01 0 0 0 5.973-2.678l6.805-7.638a1.016 1.016 0 0 0-.073-1.421z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-refund_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRefund;
